export const getOptionText =
  <T>(selectedOption?: T) =>
  ({ message, type }: { message: string; type?: T }) => {
    if (selectedOption === type) {
      return `${message} ✓`;
    }
    return message;
  };
